/**
 * Запуск фоновых видео только на десктопах
 */
if (!App.mobile) {
    document.querySelectorAll('.js-autoplay-video').forEach(video => {
        video.play();

        video
            .closest('.js-autoplay-video-container')
            .classList
            .add('_is-visible');
    });
}



// WEBPACK FOOTER //
// ./_src/js/VideoAutoplay.js